module.exports = __webpack_public_path__ + "static/img/xdfw.0693cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/xdfw.png
// module id = SBcF
// module chunks = 1